import { RootState } from 'typesafe-actions'

import { CurrentUser } from 'typings/currentUser'

export const getCurrentUser = (state: RootState): CurrentUser | undefined => state.user

export const getCurrentOrg = (state: RootState): any | undefined => state.org

export const getOrgUsers = (state: RootState): any | undefined => state.org.allUsers

export const getEnabledIntegrations = (state: RootState): any | undefined =>
  state.integrations.status
